var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1133_2023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5984 4.20002V10.5C21.5984 10.7387 21.5036 10.9676 21.3348 11.1364C21.1661 11.3052 20.9371 11.4 20.6984 11.4C20.4597 11.4 20.2308 11.3052 20.062 11.1364C19.8933 10.9676 19.7984 10.7387 19.7984 10.5V5.90002L10.7474 14.948C10.522 15.1735 10.2162 15.3001 9.89744 15.3001C9.57863 15.3001 9.27287 15.1735 9.04744 14.948C8.822 14.7226 8.69536 14.4168 8.69536 14.098C8.69536 13.7792 8.822 13.4735 9.04744 13.248L18.0984 4.20002H13.4984C13.2597 4.20002 13.0308 4.1052 12.862 3.93642C12.6933 3.76764 12.5984 3.53872 12.5984 3.30002C12.5984 3.06133 12.6933 2.83241 12.862 2.66363C13.0308 2.49485 13.2597 2.40002 13.4984 2.40002H19.7984C20.2754 2.40134 20.7325 2.59141 21.0698 2.92869C21.4071 3.26597 21.5971 3.72304 21.5984 4.20002ZM20.6984 14.7C20.4597 14.7 20.2308 14.7948 20.062 14.9636C19.8933 15.1324 19.7984 15.3613 19.7984 15.6V19.8H4.19844V4.20002H8.39844C8.63713 4.20002 8.86605 4.1052 9.03483 3.93642C9.20362 3.76764 9.29844 3.53872 9.29844 3.30002C9.29844 3.06133 9.20362 2.83241 9.03483 2.66363C8.86605 2.49485 8.63713 2.40002 8.39844 2.40002H4.19844C3.72145 2.40134 3.26438 2.59141 2.9271 2.92869C2.58982 3.26597 2.39976 3.72304 2.39844 4.20002V19.8C2.39976 20.277 2.58982 20.7341 2.9271 21.0714C3.26438 21.4086 3.72145 21.5987 4.19844 21.6H19.7984C20.2754 21.5987 20.7325 21.4086 21.0698 21.0714C21.4071 20.7341 21.5971 20.277 21.5984 19.8V15.6C21.5984 15.3613 21.5036 15.1324 21.3348 14.9636C21.1661 14.7948 20.9371 14.7 20.6984 14.7Z",
    fill: "#4A4A4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1133_2023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewIcon);
export default __webpack_public_path__ + "static/media/preview-icon.beb91438e3cbac2e7ca076ac028dc02e.svg";
export { ForwardRef as ReactComponent };